import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { FormProvider } from "react-hook-form";

import { TextField } from "@/components/Form/RHF/FormFields/TextField/Textfield.component";
import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { FormInfoProvider } from "@/utils/forms/formInfo.provider";

import {
    NewsletterUnsubscribeFormValidationSchema,
    NewsletterUnsubscribeFormValues
} from "./unsubscribeForm.schema";

const FORM_ID = "newsLetter-unsubscribe-modal";

type NewsletterUnsubscribeModalProps = {
    isLoading: boolean;
    onFormSubmit: (form: NewsletterUnsubscribeFormValues) => Promise<void>;
};

export const UnsubscribeForm = ({
    onFormSubmit,
    isLoading
}: NewsletterUnsubscribeModalProps) => {
    const { t } = useGranite();

    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            email: ""
        },
        resolver: yupResolver(NewsletterUnsubscribeFormValidationSchema)
    });

    return (
        <FormInfoProvider
            formId={FORM_ID}
            withNeverbounce={false}
        >
            {() => (
                <FormProvider {...methods}>
                    <form
                        id={FORM_ID}
                        onSubmit={methods.handleSubmit(onFormSubmit)}
                    >
                        <div className={"d-sm-flex"}>
                            <div className={"flex-grow-1 mw-100"}>
                                <TextField<NewsletterUnsubscribeFormValues>
                                    name="email"
                                    required
                                    label={t("general.form.email.label")}
                                    hideLabel={true}
                                    hideMicroCopy={true}
                                    placeholder={t(
                                        "general.form.email.placeholder"
                                    )}
                                    autoComplete={"email"}
                                />
                            </div>
                            <div className={"px-sm-3"}>
                                <Button
                                    data-test="newsletterUnsubscribeModal-button-submit"
                                    className={cn("tw:text-center tw:block")}
                                    color="primary"
                                    fullWidth
                                    type={"submit"}
                                    loading={isLoading}
                                >
                                    <strong>
                                        {t(
                                            "general.newsletterUnsubscribeModal.buttonText"
                                        )}
                                    </strong>
                                </Button>
                            </div>
                        </div>
                    </form>
                </FormProvider>
            )}
        </FormInfoProvider>
    );
};
